import { combineRules } from "fela";
import { fluid } from "~/styleguide/utils";
import { colors, gutters, layout } from "~/styleguide";
import { textStyles } from "~/styleguide/typography";
import { createComponent, FelaComponent } from "react-fela";

import WordpressLink from "~/components/global/links";
import Visual from "~/components/shared/visual";

export default function SubnavFooter({ items }) {
    return (
        <FooterLinks columns={items.length}>
            {items.map((item, d) => {
                return (
                    <FelaComponent
                        className="footer-item"
                        key={d}
                        style={footerItemStyle}
                    >
                        {item.image && (
                            <Visual
                                image={item.image}
                                extend={{
                                    height: 36,
                                    marginRight: 18,
                                    display: "inline-block",
                                    verticalAlign: "middle"
                                }}
                            />
                        )}

                        {item.link && item.text && (
                            <WordpressLink
                                url={item.link}
                                label={item.text}
                                extend={combineRules(
                                    textStyles.paragraphLarge,
                                    footerTextStyle
                                )}
                            />
                        )}
                    </FelaComponent>
                );
            })}
        </FooterLinks>
    );
}

const FooterLinks = createComponent(({ columns }) => ({
    width: "100%",
    height: 69,
    maxWidth: layout.navContentMaxWidth,
    margin: "auto",
    left: 0,
    right: 0,
    columns: columns,
    columnRule: "1px solid #000",
    columnGap: "50px",
    position: "absolute",
    bottom: 0,
    paddingTop: "16px",
    paddingBottom: "16px",
    background: colors.lightGrey,
    maxWidthMobile: {
        display: "none"
    },
    ":before": {
        content: "''",
        position: "absolute",
        height: "100%",
        width: "100%",
        top: 0,
        background: colors.lightGrey,
        left: "-100%"
    },
    ":after": {
        content: "''",
        position: "absolute",
        height: "100%",
        width: "100%",
        top: 0,
        background: colors.lightGrey,
        right: "-100%"
    },
    "@media(max-width: 1250px)": {
        extend: [fluid("paddingH", gutters.header)]
    },
    extend: [
        {
            condition: columns < 2,
            style: {
                "> div": {
                    maxWidth: "50%"
                }
            }
        }
    ]
}));

const footerTextStyle = {
    width: "85%!important",
    height: 20,
    overflow: "visible",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: "24px!important",
    display: "inline-block",
    fontSize: "18px!important",
    color: "#000000",
    verticalAlign: "middle"
};

const footerItemStyle = {
    height: 36,
    lineHeight: "100%",
    position: "relative",
    display: "block",
    alignItems: "center",
    "& .vv-visual": {
        width: 36,
        height: 36
    },
    "& .vv-align-middle": {
        display: "none"
    },
    "& a": {
        width: "100%"
    },
    ":after": {
        content: "''",
        width: 7,
        height: 7,
        backgroundColor: "#000",
        maskImage: "url('/icons/left-filled-arrow-triangle.svg')",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        transform: "rotate(180deg)",
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
        color: "#000"
    }
};
